<template>
  <div :class="{'active': active, 'complete': complete}">

    <div class="top">
      <div class="indicator">
        <slot name="indicator">
          <svg style="display: block; height: 1em; width: 1em;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path fill="currentColor" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
          </svg>
        </slot>
      </div>

      <div class="label text-larger flex flex-align-center flex-justify-between flex-grow">
        <div>
          <slot name="label">Step</slot>
        </div>
        <button
          type="button"
          class="button button-alt button-smallest button-thin"
          v-if="!active && complete"
          @click="$emit('edit')">
          Edit
        </button>
      </div>
    </div>

    <div class="contain">
      <div class="inner">

        <div v-show="active">
          <slot></slot>

          <div class="action-row flex flex-align-center">
            <button
              type="button"
              class="button button-blue-outline button-smaller"
              @click="$emit('continue')"
              :disabled="!canContinue">
              {{ continueText }}
            </button>
          </div>

          <slot name="after-action"></slot>
        </div>

        <div v-if="(!active && complete) || force">
          <slot name="display-value"></slot>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    active: {
      default: false,
      type: Boolean,
    },
    canContinue: {
      default: false,
      type: Boolean,
    },
    complete: {
      default: false,
      type: Boolean,
    },
    continueText: {
      default: 'Continue',
      type: String,
    },
    force: {
      default: false,
      type: Boolean,
    },
  },
}
</script>

<style scoped>
.contain {
  margin-top: 1em;
  padding-left: 14px;
}

.inner {
  border-left: 1px solid #DBD8D4;
  padding: .75em 1em 1em 1.65em;
  position: relative;
}

@media (min-width: 750px) {
  .inner {
    padding-right: 2em;
  }
}

.top {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}

.indicator {
  align-items: center;
  background-color: #DDE0E2;
  border: 2px solid transparent;
  border-radius: 6em;
  color: #A8AEB2;
  display: flex;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: normal;
  height: 28px;
  line-height: 1;
  justify-content: center;
  width: 28px;
}
.active .indicator {
  background-color: #FFF;
  border-color: #00549d;
  color: #00549d;
}
.complete .indicator {
  background-color: #00549d;
  color: #FFF;
}

.label {
  padding-left: .75em;
}

.action-row {
  margin-top: 2em;
}
.action-row button + button {
  margin-left: 1em;
}
</style>
